import people from '../content/people/people.json';

export function getCurrentMembers() {
  return people.filter((p) => p.status === 'current');
}

export function getAlumni() {
  return people.filter((p) => p.status === 'alumni');
}

export function getPersonBySlug(slug) {
  return people.find((p) => p.slug === slug);
}
